
import Vue from 'vue'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async createCustomer ({ commit, rootGetters }, { cardId, customerId, venueId }) {
      const customer = await platformAction({
        client: this.$api.payments.customers,
        method: 'create',
        commit,
        logError: this.$logError,
        commitData: false,
        params: {
          venueId,
          memberId: rootGetters['user/account/id'],
          transactionType: 'membership',
          gatewayAttributes: {
            customerId,
            cardId
          }
        }
      })

      commit('saveCustomer', customer)

      return customer
    }
  },
  getters: {
    ...platformGetters,
    customer: s => s.customer
  },
  mutations: {
    ...platformMutations,
    saveCustomer: (s, customer) => {
      Vue.set(s, 'data', customer)
    }
  }
}
